export default "__VITE_ASSET__FZTfkI4F__"